import React, { Component } from 'react';
import { BaseURLDev, headers } from '../../../../../_utils/config';
import { toDMYDate } from '../../../../../_utils/convert_datetime';

import { 
   Table, Menu, Pagination, Input, Button, Segment,Header, Loader
} from 'semantic-ui-react';
import _ from 'lodash';
import ModalDetail from './ModalDetail';
import swal from 'sweetalert'
import { toIDR } from '../../../../../_utils/tocurrency';

export default class BPTrash extends Component {
   constructor(props){
      super(props);
      this.state = {
         column: null,
         data: [],
         direction: null,
         requests: true,
         activePage: 1,
         totalPages: 0,
         itemPerPage: 0,
         totalItem: 0,
         q: "",
         
         is_detail: false,
         data_detail: null,
         loading_detail: false,

         is_edit: false,
         data_edit: null,
         loading_edit: false,
         pageActive: 1,

      }

      this.handleSort = this.handleSort.bind(this);
      this.handlePaginationChange = this.handlePaginationChange.bind(this);
      this.searchBpSts = this.searchBpSts.bind(this);
      this.onCloseDetail = this.onCloseDetail.bind(this);
      this.onOpenDetail = this.onOpenDetail.bind(this);
      this.onRefresh = this.onRefresh.bind(this);
      
   }

   onOpenDetail = (e, { index }) => {
      const { data } = this.state
      this.setState({
         is_detail:true,
         data_detail:data[index],
         loading_detail:false
      });
   }

   onCloseDetail = () => {
      this.setState({
         is_detail:false,
         data_detail:null
      });
   }

   handleSort = clickedColumn => () => {
      const { column, data, direction } = this.state

      if (column !== clickedColumn) {
         this.setState({
            column: clickedColumn,
            data: _.sortBy(data, [clickedColumn]),
            direction: 'ascending',
         })

         return
      }

      this.setState({
         data: data.reverse(),
         direction: direction === 'ascending' ? 'descending' : 'ascending',
      })
   }

   onRefresh(){
      this.setState({ q: "", requests: true });
      this.onLoadData();
   }

   onLoadData(){
      fetch(`${BaseURLDev}/bp/ontrash`,{headers})
      .then(response => {
         if (!response.ok) { 
            swal('Load data gagal',  { icon:'error' })
            this.setState({requests:false});
            return Promise.reject(response.statusText);
         }
         return response.json();
      })
      .then(resJSON => {
         this.setState({
            data: resJSON.data,
            totalPages: resJSON.totalPage,
            requests: false,
            totalItem: resJSON.totalItem,
            itemPerPage: resJSON.itemPerPage,
         })
      })
      .catch(err =>{
            swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
              icon: "error",
            }); 
      });
   }

   componentWillMount = () => this.onLoadData();

   handlePaginationChange = (e, { activePage }) => {
      if (this.state.pageActive === activePage){
         return false;
      }
      this.setState({ activePage, pageActive: activePage, requests: true })
      let url = null;
      if(this.state.q!==""){
         url = `${BaseURLDev}/bp/ontrash?page=${activePage}&q=${this.state.q}`
      }else{
         url = `${BaseURLDev}/bp/ontrash?page=${activePage}`         
      }
      fetch(url,{headers})
      .then(response => response.json())
      .then(resJSON => {
         this.setState({
            data: resJSON.data,
            totalPages: resJSON.totalPage,
            requests: false,
            totalItem: resJSON.totalItem,
            itemPerPage: resJSON.itemPerPage,
         })
      });
   }

   searchBpSts(e){
      this.setState({q:e.target.value, requests:false});
      fetch(`${BaseURLDev}/bp/ontrash?q=${e.target.value}`,{headers})
      .then(response => response.json())
      .then(resJSON => {
         this.setState({
            data: resJSON.data,
            totalPages: resJSON.totalPage,
            requests: false,
            totalItem: resJSON.totalItem,
            itemPerPage: resJSON.itemPerPage,
         })
      });
   }

   render() {
      const { column, data, direction,totalPages,activePage } = this.state;
     
      return (
         <div>
            <div>                     
               <Menu>
                  <Menu.Item>                     
                    <Button.Group size='small'>
                        {/* <Button content="Filter" disabled={this.state.startDate===null && this.state.endDate===null} color='green' icon='filter' onClick={this.onFilter}/> */}
                        {/* <Button content="Export" disabled={this.state.requests} color='red' icon='download' onClick={this.onOpenExport} /> */}
                        <Button color='blue' disabled={this.state.requests} content="Refresh" icon='refresh' onClick={this.onRefresh} />                        
                    </Button.Group>
                  </Menu.Item>
                  <Menu.Item>
                     <Header>List data BP telah terhapus</Header>
                  </Menu.Item>
                  <Menu.Item position="right">
                     <Input type="text"
                        icon="search"
                        autoFocus 
                        value={this.state.q}
                        placeholder="Masukkan Nomor BP"
                        style={{width:'200px'}}
                        onChange={this.searchBpSts}
                         />
                  </Menu.Item>
               </Menu>
               <Segment loading={(this.state.requests || this.state.loading_edit || this.state.loading_detail)}>
                  <Table size='small' sortable celled>
                     <Table.Header fullWidth>
                          <Table.Row>
                            <Table.HeaderCell colSpan='7'>
                                <Pagination activePage={activePage} 
                                  onPageChange={this.handlePaginationChange} 
                                  totalPages={totalPages}
                                />
                            </Table.HeaderCell>
                          </Table.Row>
                        <Table.Row>
                           <Table.HeaderCell style={{width:"4%",textAlign:"center"}}>No.</Table.HeaderCell>
                           <Table.HeaderCell style={{width:"5%",textAlign:"center"}}>#</Table.HeaderCell>
                           {/* <Table.HeaderCell style={{width:"15%"}}>SKPD</Table.HeaderCell> */}
                           {/* <Table.HeaderCell style={{width:"15%"}}>OPD</Table.HeaderCell> */}
                           <Table.HeaderCell style={{width:"10%"}} sorted={column === 'no_bukti' ? direction : null} onClick={this.handleSort('no_bukti')}>
                              Nomor
                           </Table.HeaderCell>
                           <Table.HeaderCell style={{width:"8%"}} sorted={column === 'created_at' ? direction : null} onClick={this.handleSort('created_at')}>
                           Pembuatan
                           </Table.HeaderCell>
                           <Table.HeaderCell style={{width:"8%"}}>Total Rincian</Table.HeaderCell>
                           <Table.HeaderCell>Total Nilai</Table.HeaderCell>
                           <Table.HeaderCell>Keterangan</Table.HeaderCell>                           
                        </Table.Row>
                     </Table.Header>
                     <Table.Body>
                        {data.length === 0 && 
                           <Table.Row>
                              <Table.Cell colSpan="7">Data tidak ditemukan</Table.Cell>                           
                           </Table.Row>
                        }
                        {_.map(data, (item,i) => (
                           <Table.Row key={i}> 
                              <Table.Cell>{i+1+(activePage-1)*this.state.itemPerPage}.</Table.Cell>                                                   
                              <Table.Cell style={{textAlign:"center"}}>
                                 <Button.Group size='mini'>
                                    <Button color='blue' 
                                       icon='block layout' 
                                       index={i}                                          
                                       onClick={this.onOpenDetail} 
                                    />
                                 </Button.Group>
                              </Table.Cell>
                              {/* <Table.Cell>{item.org_skpd.nama}</Table.Cell> */}
                              {/* <Table.Cell>{item.org_opd.nama}</Table.Cell> */}
                              <Table.Cell>{item.no_bukti}</Table.Cell>
                              <Table.Cell>{toDMYDate(item.created_at)}</Table.Cell>
                              <Table.Cell>{item.total_rincian} Rincian</Table.Cell>
                              <Table.Cell>{toIDR(item.total_nilai)}</Table.Cell>
                              <Table.Cell>{item.uraian}</Table.Cell>
                           </Table.Row>
                        ))}
                     </Table.Body>
                     <Table.Footer fullWidth>
                        <Table.Row>
                           <Table.HeaderCell colSpan='8'>
                              <Pagination activePage={activePage} 
                                 onPageChange={this.handlePaginationChange} 
                                 totalPages={totalPages}
                              />
                           </Table.HeaderCell>
                        </Table.Row>
                     </Table.Footer>
                  </Table>
               </Segment>
              
               {this.state.is_detail && 
                  <ModalDetail 
                     open={this.state.is_detail}
                     data_detail={this.state.data_detail} 
                     onClose={this.onCloseDetail} />
               }
            </div>
         </div>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/opd/_bp/BPTrash.js